import Component from "@glimmer/component"
import type {
  GroupMembershipPotential,
  GroupMembershipRequested,
  IndividualMembership,
} from "@shared/models/group"
import FindDoc from "cc-frontend/helpers/find-doc"
import { use } from "ember-could-get-used-to-this"

interface Signature {
  Args: {
    row: IndividualMembership | GroupMembershipRequested | GroupMembershipPotential
  }
}

export default class GroupMembersTableAvatarCell extends Component<Signature> {
  @use userSummary = new FindDoc(() => {
    let userId =
      this.args.row.type === "group-membership-accepted" ||
      this.args.row.type === "group-membership-requested" ||
      this.args.row.type === "group-membership-potential"
        ? this.args.row.attributes.userId
        : null
    return ["user-summary", userId]
  })
}
